var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDoors = function SvgIconDoors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(0 40) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,24a1,1,0,0,1,0-2H9V2H1A1,1,0,0,1,1,0h9a1,1,0,0,1,1,1V23a1,1,0,0,1-1,1Zm13-2a1,1,0,1,1,0-2h2V4H14a1,1,0,1,1,0-2h3a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1Zm7-3a1,1,0,1,1,0-2h1V7H21a1,1,0,1,1,0-2h2a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1ZM5,13a1,1,0,1,1,0-2H7a1,1,0,0,1,0,2Z",
    transform: "translate(8 8)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDoors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-doors.e439270f.svg";
export { ForwardRef as ReactComponent };